import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { WSList, WSPanel, WSText } from "@wingspanhq/fe-component-library";
import { FieldView } from "../../../../shared/components/FieldView/FieldView";
import React from "react";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryMemberProfile } from "../../../../query/users/queries";
import { WSQueries } from "../../../../query/WSQuery";
import { wsName } from "@wingspanhq/utils/dist/name/wsName";
import { AddressText } from "../../../../shared/components/AddressText/AddressText";

export const CardBillingInfo: React.FC<{ card: cardApiSpec.Card }> = ({
  card
}) => {
  const userId = useUserId();
  const memberProfileQuery = useQueryMemberProfile(userId);

  return (
    <WSPanel>
      <WSQueries queries={{ memberProfileQuery }}>
        {({ memberProfileQueryData }) => {
          const names = wsName({
            member: memberProfileQueryData,
            user: memberProfileQueryData.user
          });

          return (
            <WSList gap="L">
              <FieldView label="Name on card" value={names.fullName} />
              <FieldView
                label="Billing address"
                value={
                  <WSText.ParagraphSm as="pre">
                    <AddressText
                      placeholder="-"
                      {...memberProfileQueryData.profile.address}
                    />
                  </WSText.ParagraphSm>
                }
              />
            </WSList>
          );
        }}
      </WSQueries>
    </WSPanel>
  );
};
